import React from "react"

import { WithClassName } from "shared/types/WithClassName"
import { ProductInformation } from "shared/types/__generated__/graphql"

import { ProductConfiguratorSummaryCardView } from "./ProductConfiguratorSummaryCardView"
import { useProductConfiguratorSummaryCardViewModel } from "./hooks/useProductConfiguratorSummaryCardViewModel"

export interface ProductConfiguratorSummaryCardModel {
  productImage?: React.ReactNode
  productTitle?: string

  productInformation?: ProductInformation | null | undefined
  isLoadingProductInformation?: boolean
}

export interface ProductConfiguratorSummaryCardProps
  extends ProductConfiguratorSummaryCardModel,
    WithClassName {
  /**
   * Replaces the tabbed recap with the plain variant keys of the product and its
   * addons. Passed by the view rather than derived from `activeStep` so both modes
   * can be rendered in isolation.
   */
  showVariantKeysOnly?: boolean
}

export const ProductConfiguratorSummaryCard = React.memo(
  (props: ProductConfiguratorSummaryCardProps) => (
    <ProductConfiguratorSummaryCardView
      {...useProductConfiguratorSummaryCardViewModel(props)}
    />
  )
)
